<template lang="pug">
section
  s-page-title(
    :previous='true'
    :title='id ? "Редактирование категории блога" : "Добавление категории блога"'
  )
  v-card
    v-container(grid-list-xl fluid)
      v-layout(wrap)
        v-flex(xs12)
          v-text-field(
            :error='errors.has("id")'
            :error-messages='errors.first("id")'
            v-model='model.id'
            label='ID группы на латинице'
            :readonly="!!this.id"
          )
        v-flex(xs12)
          v-text-field(
            :error='errors.has("name")'
            :error-messages='errors.first("name")'
            v-model='model.name'
            label='Название категории'
          )
        v-flex(xs12)
          v-text-field(
            :error='errors.has("meta_title")'
            :error-messages='errors.first("meta_title")'
            v-model='model.meta_title'
            label='TITLE страницы'
          )
        v-flex(xs12)
          v-text-field(
            :error='errors.has("meta_h1")'
            :error-messages='errors.first("meta_h1")'
            v-model='model.meta_h1'
            label='H1 страницы'
          )
        v-flex(xs12)
          v-textarea(
            :error='errors.has("meta_description")'
            :error-messages='errors.first("meta_description")'
            v-model='model.meta_description'
            label='DESCRIPTION страницы'
          )
    v-card-actions(class='large')
      v-spacer
      s-back-btn
      v-btn(
        @click='onSave'
        :loading='isLoading'
        color='primary'
        depressed
      ) Сохранить
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  props: ['id'],

  data: () => ({
    model: {}
  }),

  async created() {
    if (!this.id) return
    this.updateItem()
  },

  methods: {
    async updateItem() {
      const response = await this.fetchSingle({ id: this.id.toString() })
      this.model = response.data
    },

    async onSave() {
      try {
        if (this.id) {
          await this.update({
            id: this.id,
            data: this.model
          })
        } else {
          await this.create({
            data: this.model
          })
        }

        this.$root.showSnack('Сохранено')
        this.$router.push({ name: 'Seo.Categories' })
      } catch (e) {
        this.$showServerErrors(e)
      }
    },

    ...mapActions('seo/categories', [
      'fetchSingle',
      'update',
      'create'
    ])
  },

  computed: {
    ...mapGetters('seo/categories', ['isLoading'])
  }
}
</script>

<style scoped>
.small textarea {
  font-size: 12px;
}
</style>
